<template>
  <div class="Page">
    <div class="page-flex">
      <!--      <div class="page-flex-div">
        <router-view></router-view>
      </div>-->
      <transition :name="transitionName">
        <router-view class="animationnavigationslide"></router-view>
      </transition>
    </div>
    <div class="navigation" v-if="navClose && !myshow">
      <div
        class="customNavigationBar-div"
        v-for="(item, index) in data.list"
        :key="index"
        @click="pageClick(item.pagePath, index)"
      >
        <!-- <img :src="item.iconPath" :class="['customNavigationBar-img-1',pageIndex == index? 'customNavigationBar-none' : '']" />
        <img :src="item.selectedIconPath" :class="['customNavigationBar-img-1',pageIndex != index? 'customNavigationBar-none' : '']" />-->
        <div
          :class="['iconfont', item.icon]"
          :style="{ color: pageIndex != index ? data.color : data.selectedColor, 'font-size': '20px' }"
        ></div>
        <div
          :style="{ color: pageIndex != index ? data.color : data.selectedColor, 'font-size': '10px' }"
        >{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { AlbumgetBaseInfo } from '@/request/api.js'

export default {
  name: 'App',
  data () {
    return {
      transitionName: 'slide-left',
      pageIndex: 0,
      navClose: true,
      transitionmeta: [],
      resizeClose: false,
      login: false,
    }
  },
  computed: {
    myshow () {
      return this.$store.state.myshow
    },
    ...mapState(['data']),
  },
  // 监听器
  watch: {
    // 方法1
    $route (to, from) {
      this.$api.commit('myshow', false)

      // 监听路由是否变化
      this.routeClose()
      // ////////////////////////////////////处理子界跳入主界
      if (to.meta.index <= 5 && from.meta.index > 5) {
        this.transitionName = 'slide-right'
        return
      }
      // ////////////////////////////////////处理主界面的顺序
      if (to.meta.index <= 5 && from.meta.index <= 5) {
        if (to.meta.index < from.meta.index) {
          this.transitionName = 'slide-right'
        } else {
          this.transitionName = 'slide-left'
        }
        return
      }
      // ///////////////////////////////////
      const number = this.transitionmeta.indexOf(to.meta.index)
      if (number != -1) {
        this.transitionName = 'slide-right'
        this.transitionmeta.splice(number, 1)
      } else {
        this.transitionName = 'slide-left'
        this.transitionmeta.push(from.meta.index)
      }
    },
  },
  mounted () {
    window.addEventListener('resize', this.renderResize, false)
  },
  created () {
    this.$router.push({
      path: window.location.href.substring(window.location.href.indexOf('#') + 1, window.location.href.length),
    })
  },
  methods: {
    renderResize () {
      const width = document.documentElement.clientWidth
      const height = document.documentElement.clientHeight
      this.resizeClose = width > height
    },
    async routeClose () {
      if (!this.login) {
        const res = await AlbumgetBaseInfo('')
        this.login = !this.login
        this.$store.commit('getRouter', res)
      }
      let close = false
      let index
      const list = this.data.list.map((item) => item.pagePath)
      const path = `${this.$route.path}?`
      switch (path) {
        case '/homeCatalog?':
          close = true
          index = list.indexOf(`${path}`)
          break
        case '/homeCatalog/morePaeg?':
          close = true
          index = list.indexOf(`${path}`)
          break
        case '/searchCatalog/index?':
          close = true
          index = list.indexOf(`${path}`)
          break
        case '/classifyCatalog?':
          close = true
          index = list.indexOf(`${path}`)
          break
        case '/contactCatalog/index?':
          close = true
          index = list.indexOf(`${path}`)
          break
        case '/homeCatalog/more?':
          close = true
          index = 999
          break
      }
      this.pageIndex = index
      this.navClose = close
    },
    pageClick (url, index) {
      this.pageIndex = index
      this.$router.push({
        path: `${url}alias=${this.$store.state.loginInfo.album_alias}`,
      })
    },
  },
};
</script>

<style>
@import url('assets/font/iconfont.css');
@import url('assets/css/APP.css');

html,
body,
div,
dl,
dt,
dd,
ol,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
button,
fieldset,
form,
input,
legend,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}

html,
body,
.Page {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 0.7rem;
}

.page-flex {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

input {
  border: none;
  background-color: rgba(211, 211, 211, 0);
}

img {
  display: block;
}

.navigation {
  width: 100%;
  border-top: 1px solid #f4f4f4;
  display: flex;
  flex-wrap: nowrap;
  background-color: #ffffff;
  overflow: hidden;
  animation: navigation-height 0.5s forwards;
  align-items: center;
  height: 3.8rem;
}

@keyframes navigation-height {
  0% {
    transform: translateY(3.8rem);
  }

  100% {
    transform: translateY(0);
  }
}

.customNavigationBar {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.customNavigationBar > div {
  width: 100%;
  height: 4.8rem;
  background-color: #fff;
  border-top: 1px solid #d5d6d8;
}

.customNavigationBar > div:nth-child(1) {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 500;
  display: flex;
  flex-wrap: nowrap;
}

.customNavigationBar > div:nth-child(2) {
  visibility: hidden;
}

.customNavigationBar-div {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
  position: relative;
}

.customNavigationBar-img-1 {
  width: 1.5rem;
  height: 1.5rem;
  margin-bottom: 0.2rem;
}

.customNavigationBar-vigat {
  width: 1.8rem;
  height: 1.8rem;
}

.customNavigationBar-none {
  display: none;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.5s;
  position: absolute;
}

.animationnavigationslide {
  animation: navigation-slide 100000000s;
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-enter {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translateX(-100%);
}
</style>
